<template>
  <div class="xiaobu-container" v-closeSelect="'window'">
    <el-form ref="queryForm" :model="queryParams" :inline="true" class="search-form clearfix">
      <el-form-item class="search-field fl five-per-row" label="入库单号" prop="entryNo">
        <el-input v-model.trim="queryParams.entryNo" placeholder="请输入入库单号" clearable
          @keyup.enter.native="handleQuery" />
      </el-form-item>
      <el-form-item class="search-field fl five-per-row" label="入库仓库" prop="wareHouseId">
        <el-cascader aria-hidden="false" :options="wareHouseData" clearable :props="defaultProps"
          v-model="queryParams.wareHouseId" @change="handleQuery" placeholder="请选择入库仓库" />
      </el-form-item>
      <el-form-item class="search-field fl five-per-row" label="入库类型" prop="entryType">
        <el-select-dict dictType="ENTRY_TYPE" clearable placeholder="请选择入库类型" v-model="queryParams.entryType"
          @dictChange="handleQuery"></el-select-dict>
      </el-form-item>
      <el-form-item class="search-field fl five-per-row" label="供应商姓名" prop="customerName">
         <el-input v-model.trim="queryParams.customerName" placeholder="请输入供应商姓名" clearable
          @keyup.enter.native="handleQuery" />
      </el-form-item>
      <el-form-item class="search-field fl five-per-row" label="入库状态" prop="entryStatus">
        <el-select-dict dictType="ENTRY_STATUS" clearable placeholder="请选择入库状态" v-model="queryParams.entryStatus"
          @dictChange="handleQuery"></el-select-dict>
      </el-form-item>
      <el-form-item class="search-field fl" label="渠道" prop="channel">
        <el-select-dict dictType="CHANNEL" clearable placeholder="请选择渠道" v-model="queryParams.channel"
          @change="handleQuery"></el-select-dict>
      </el-form-item>
      <el-form-item class="search-field fl five-per-row" label="创建时间" prop="beginTime">
        <el-date-picker v-model="dateRange" value-format="yyyy-MM-dd HH:mm:ss" type="daterange" @change="handleQuery"
          range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
      </el-form-item>

      <el-form-item class="fr">
        <el-button plain @click="resetQuery">重 置</el-button>
        <el-button type="primary" @click="handleQuery">查 询</el-button>
      </el-form-item>
    </el-form>
    <div class="table-wrap">
      <div class="table-control-box">
        <el-button v-hasPermission="['inventory:entry:create']" type="primary" plain icon="el-icon-plus" size="mini"
          @click="handleAdd">新增</el-button>
        <el-button v-hasPermission="['inventory:entry:update']" type="success" plain icon="el-icon-edit" size="mini"
          :disabled="single" @click="handleUpdate">编辑</el-button>
        <el-button v-hasPermission="['inventory:entry:delete']" type="danger" plain icon="el-icon-delete" size="mini"
          :disabled="multiple" @click="handleBatchDelete">删除</el-button>
      </div>
      <div class="table-box">
        <auto-height-table ref="entryTable" :class="{ empty: list.length === 0 }" empty-text=" " v-loading="loading" :data="list"
          row-key="entryId" @selection-change="handleSelectionChange" @row-click="clickRow">
          <el-table-column type="selection" :selectable="checkSelectable" :reserve-selection="true" width="55"
            align="center" />
          <el-table-column label="入库单号" prop="entryNo" align="center" min-width="168px" >
            <template slot-scope="scope">
              <el-link v-if="mixinHasPermi(['inventory:record:list']) && scope.row.entryStatus === '1'" type="primary" @click="mixinHandleGoRecordList(scope.row.entryNo)">{{ scope.row.entryNo }}</el-link>
              <span v-else>{{ scope.row.entryNo }}</span>
            </template>
          </el-table-column>
          <el-table-column label="入库仓库" prop="wareHouseIdList" align="center" min-width="168px" show-overflow-tooltip>
            <template slot-scope="scope">
              <span>{{ getWareHouseNameByList(scope.row.wareHouseIdList) }}</span>
            </template>
          </el-table-column>
          <el-table-column-dict dictType="ENTRY_TYPE" label="入库类型" prop="entryType" align="center" min-width="120px" />
          <el-table-column label="供应商姓名" prop="customerName" align="center" min-width="156px" show-overflow-tooltip />
          <el-table-column-dict dictType="ENTRY_STATUS" dictTypeNode="tag" label="入库状态" align="center"
            prop="entryStatus" min-width="100px"></el-table-column-dict>
          <el-table-column-dict dictType="CHANNEL" dictTypeNode="tag" label="渠道" align="center" prop="channel"
            min-width="100px"></el-table-column-dict>
          <el-table-column label="操作人" prop="creator.userName" align="center" min-width="168px" show-overflow-tooltip>
            <template slot-scope="scope">
              创建人：{{ scope.row.creator.userName }}<br />
              更新人：{{ scope.row.updater.userName }}
            </template>
          </el-table-column>
          <el-table-column dateFormat="datetime" label="操作时间" align="center" prop="createTime" min-width="256px">
            <template slot-scope="scope">
              创建时间：{{ scope.row.createTime | formatDate("datetime") }}<br />
              更新时间：{{ scope.row.updateTime | formatDate("datetime") }}
            </template>
          </el-table-column>
          <el-table-column label="操作" v-if="
            mixinHasPermi([
              'inventory:entry:read',
              'inventory:entry:delete',
            ])
          " align="center" width="228px" fixed="right" class-name="small-padding ">
            <template slot-scope="scope">
              <el-button v-hasPermission="['inventory:entry:read']" size="mini" type="primary" icon="el-icon-view"
                @click.native.stop="handleUpdate(scope.row)">查看</el-button>
              <el-button v-hasPermission="['inventory:entry:delete']" :disabled="scope.row.entryStatus === '1'" size="mini"
                type="danger" icon="el-icon-delete" @click.native.stop="handleDelete(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </auto-height-table>

        <pagination v-show="total > 0" :total="total" :page.sync="queryParams.pageNum"
          :limit.sync="queryParams.pageSize" @pagination="getList" />
      </div>
    </div>
    <entry-dialog ref="entryDialog" :visible.sync="open" :modal-append-to-body="false" :close-on-click-modal="false"
      :isUpdate="isUpdate" :baseForm="baseForm" @close="open = false" @successs="init" :wareHouseData="wareHouseData" width="1280px"></entry-dialog>
  </div>
</template>

<script>
import EntryDialog from "./components/entry-dialog.vue"
import { entryApi, wareHouseApi } from "@/api"
import {markNonLeafNodes} from "@/utils/tree"
import { getPathByTreeValue } from "vue2-element-admin-plugin"

export default {
  name: "inventoryEntryManage",
  components: {
    EntryDialog
  },
  data() {
    return {
      wareHouseData: [], // 仓库树 数据
      defaultProps: {
        checkStrictly: true,
        value: "wareHouseId",
        children: "children",
        label: "wareHouseName"
      },
      selection: [], // 选中的列表数据
      // 非单个禁用
      single: true,
      // 非多个禁用(0个禁用)
      multiple: true,
      isUpdate: false, // 是否是编辑
      //搜索条件参数
      queryParams: {
        entryNo: "", // 入库单号
        wareHouseId: "", // 入库仓库
        entryType: "", // 入库类型
        customerName: "", // 供应商
        entryStatus: "", // 配置项状态
        channel: "", // 渠道
        beginTime: "",
        endTime: "",
        pageNum: 1,
        pageSize: 10
      },
      dateRange: [],
      list: [],
      loading: false,
      total: 0,
      open: false,
      // 表单参数
      baseForm: {
        entryNo: "",
        entryType: "", // 
        entryStatus: "", // 
        outNo: "", // 关联的出库单号
        customerId: "", // 供应商id
        customerName: "", // 供应商
        spuListJson: "", // spu列表
        entrySumNumber: "", //合计入库数量
        entrySumCostPrice: "", // 合计入库成本价
        remark: "" // 备注
      }
    }
  },
  watch: {
    open(val) {
      if (!val) {
        this.isUpdate = false
        this.baseForm = {
          entryNo: "",
          entryType: "", // 
          entryStatus: "", // 
          outNo: "", // 关联的出库单号
          customerId: "", // 供应商id
          customerName: "", // 供应商
          spuListJson: "", // spu列表
          entrySumNumber: "", //合计入库数量
          entrySumCostPrice: "", // 合计入库成本价
          remark: "" // 备注
        }
        this.$refs.entryDialog && this.$refs.entryDialog.resetForm()
      }
    }
  },
  async created() {

    const { query } = this.$route
    if (query.operateNo || query.billNo || query.entryNo) {
      this.queryParams.entryNo = query.operateNo || query.billNo || query.entryNo
    }
    await this.init()
  },
  methods: {
    // 初始化 入库成功后得重新获取仓库数据
    async init() { 
      await this.getWareHouseTree()
      //获取列表
      this.getList()
    },
    // 通过仓库id数组 返回仓库名字
    getWareHouseNameByList(wareHouseIdList) {
      const wareHouseNameList = []
      for (let i = 0; i < wareHouseIdList.length; i++) {
        const wareHouseId = wareHouseIdList[i]
        const name = this.getWareHouseName(wareHouseId)
        wareHouseNameList.push(name)
      }
      return wareHouseNameList.join("；")
    },
    // 获取仓库名字
    getWareHouseName(val) {
      if (!val) {
        return ""
      }
      const wareHouseId = Array.isArray(val) ? val[val.length - 1] : val
      const list = getPathByTreeValue(this.wareHouseData, wareHouseId, { targetField: "wareHouseId", childrenField: "children" }, true)
      return list[list.length - 1].labelArr.join("/")
    },
    // 获取仓库列表
    getWareHouseTree() {
      return wareHouseApi.getWareHouseTree().then((data) => {
        this.wareHouseData = markNonLeafNodes(data, this.mixinWareHouseIdList, {idField: "wareHouseId"})
      })
    },
    // 已入库的 禁止操作
    checkSelectable(row, index) {
      if (row.entryStatus === "1") {
        return false
      } else {
        return true
      }
    },
    //点击行
    clickRow(row) {
      //已入库的 不做处理
      if (row.entryStatus === "1") {
        return
      }
      this.$refs.entryTable.toggleRowSelection(row)
    },
    //批量删除
    handleBatchDelete() {
      // 让按钮返回原样
      this.mixinBtnBlur()
            
      let str = ""
      const ids = []
      for (let i = 0; i < this.selection.length; i++) {
        const item = this.selection[i]
        ids.push(item.entryId)
        str += item.entryNo
        if (i !== this.selection.length - 1) {
          str += ", "
        }
      }
      this.$modal
        .confirm('删除后将无法找回！是否确认删除入库单号为"【' + str + '】"的数据项？')
        .then(function() {
          return entryApi.batchDeleteItems({ ids })
        })
        .then(() => {
          this.handleQuery()
          this.$modal.msgSuccess("批量删除入库单成功")
        })
    },
    /** 编辑按钮操作 */
    handleUpdate(row) {
      if (!row.entryId) {
        this.isUpdate = true
      }
      const id = row.entryId || (this.selection[0] && this.selection[0].entryId)

      entryApi.getDetailById({ id }).then((data) => {
        this.baseForm = Object.assign(this.baseForm, data)
        this.open = true
      })
    },
    // 多选框选中数据
    handleSelectionChange(selection) {
      this.selection = selection
      this.single = selection.length !== 1
      this.multiple = !selection.length
    },

    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParams.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.dateRange = []
      this.mixinResetForm("queryForm")
      // 库存单号重置
      this.queryParams.entryNo = ""

      this.handleQuery()
    },
    /** 查询列表 */
    getList() {
      // 清空所有选中的数据
      this.$refs.entryTable && this.$refs.entryTable.clearSelection()
      this.loading = true
      const params = JSON.parse(JSON.stringify(this.queryParams))
      params.wareHouseId = (Array.isArray(params.wareHouseId) ? params.wareHouseId[params.wareHouseId.length - 1] : params.wareHouseId) || null
      entryApi
        .getList(this.mixinAddDateRange(params, this.dateRange))
        .then((response) => {
          this.list = response.rows
          this.total = response.total
          this.loading = false
        })
        .catch((err) => {
          if (err?.name === "CanceledError") {
            return
          }
          this.loading = false
        })
    },
    /** 新增按钮操作 */
    handleAdd() {
      this.open = true
    },
    /** 删除按钮操作 */
    handleDelete(row) {
      // 让按钮返回原样
      this.mixinBtnBlur()

      const id = row.entryId
      this.$modal
        .confirm('删除后将无法找回！是否确认删除入库单号为"' + row.entryNo + '"的数据项？')
        .then(function() {
          return entryApi.deleteItem({ id })
        })
        .then(() => {
          this.handleQuery()
          // 判断删除的项是否被勾选了
          const flag = this.selection.find((item) => item.entryId === id)
          flag && this.$refs.entryTable.toggleRowSelection(row, false)
          this.$modal.msgSuccess("删除成功")
        })
    }
  }
}
</script>